import type { EchoflicksSessionMedia } from "../types";

export const NOAH_KYRA_ECHO_ID = "8ba6bbd8-7fdc-40a2-a54d-a701c06ee318";

export const NOAH_KYRA_REFERENCE_IMAGES = {
  Noah: ["image_6.jpg", "image_9.jpg", "image_11.jpg", "image_19.jpg"],
  Kyra: ["image_2.jpg", "image_8.jpg", "image_12.jpg", "image_14.jpg"],
} as const;

export const NOAH_KYRA_SAME_FRAME_IMAGES = [
  {
    filename: "image_1.jpg",
    left: "Noah",
    right: "Kyra",
    result: "Unknown / Unknown",
  },
  {
    filename: "image_5.jpg",
    left: "Kyra",
    right: "Noah",
    result: "Kyra / Noah",
  },
  {
    filename: "image_18.jpg",
    left: "Kyra",
    right: "Noah",
    result: "Unknown / Noah",
  },
  {
    filename: "image_22.jpg",
    left: "Kyra",
    right: "Noah",
    result: "Kyra / Noah",
  },
] as const;

export const NOAH_KYRA_ACCEPTED_DECISIONS = [
  {
    instance: "image_5.jpg · left",
    expected: "Kyra",
    result: "Kyra",
    similarity: 0.386,
    margin: 0.1542,
  },
  {
    instance: "image_5.jpg · right",
    expected: "Noah",
    result: "Noah",
    similarity: 0.3701,
    margin: 0.149,
  },
  {
    instance: "image_15.jpg",
    expected: "Kyra",
    result: "Kyra",
    similarity: 0.5732,
    margin: 0.2525,
  },
  {
    instance: "image_17.jpg",
    expected: "Noah",
    result: "Noah",
    similarity: 0.4715,
    margin: 0.1075,
  },
  {
    instance: "image_18.jpg · right",
    expected: "Noah",
    result: "Noah",
    similarity: 0.4771,
    margin: 0.2082,
  },
  {
    instance: "image_20.jpg",
    expected: "Kyra",
    result: "Kyra",
    similarity: 0.4531,
    margin: 0.2031,
  },
  {
    instance: "image_21.jpg",
    expected: "Noah",
    result: "Noah",
    similarity: 0.4421,
    margin: 0.243,
  },
  {
    instance: "image_22.jpg · left",
    expected: "Kyra",
    result: "Kyra",
    similarity: 0.478,
    margin: 0.2861,
  },
  {
    instance: "image_22.jpg · right",
    expected: "Noah",
    result: "Noah",
    similarity: 0.3964,
    margin: 0.1051,
  },
] as const;

export const NOAH_KYRA_ABSTAINED_DECISION_COUNT = 11;

const filenameFromMedia = (media: EchoflicksSessionMedia): string | null => {
  const locator = media.storage_path ?? media.s3_key ?? media.url;
  if (!locator) return null;
  return locator.split(/[\\/]/).at(-1)?.toLowerCase() ?? null;
};

export const findUploadedImage = (
  media: EchoflicksSessionMedia[],
  filename: string,
): EchoflicksSessionMedia | null =>
  media.find(
    (item) =>
      item.kind === "uploaded_media" &&
      filenameFromMedia(item) === filename.toLowerCase(),
  ) ?? null;
